import axios, { AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import { immediateToast } from "izitoast-react";
import { getConfig, AppConfig } from "src/config/Config";

let publicApiInstance: AxiosInstance | null = null;

export function getPublicClient(): AxiosInstance {
  if (publicApiInstance) {
    return publicApiInstance;
  }

  const config: AppConfig = getConfig();

  const api = axios.create({
    baseURL: config.PUBLIC_API_URL,
    headers: {
      "Content-Type": "application/json"
      // partner_id: config.PARTNER_ID
    }
  });

  api.interceptors.request.use(async (configuration: InternalAxiosRequestConfig) => {
    configuration.headers = configuration.headers || {};
    configuration.headers["x-api-key"] = getConfig().X_API_KEY;
    return configuration;
  });

  api.interceptors.response.use((response: AxiosResponse) => {
    if (response.data.errors) {
      const errorMessage = response.data.errors[0].message;
      let messageObj: { message?: string } | undefined;

      try {
        messageObj = JSON.parse(errorMessage);
      } catch (error) {
        console.log(error);
        messageObj = undefined;
      }

      immediateToast("error", {
        message: messageObj?.message ?? errorMessage,
        timeout: 3000,
        position: "topCenter"
      });
      throw new Error(response.data.errors[0]);
    }
    return response.data;
  });

  publicApiInstance = api;
  return publicApiInstance;
}

const publicClient = (data: { query: string; variables?: any }) => {
  return getPublicClient().post("/graphql", data);
};

export default publicClient;
